module.exports = __webpack_public_path__ + "static/media/avanzano.5c4f47d9.jpeg";